import { createContext } from "@-/com.npmjs.use-context-selectors";

type LearnDeckHistory = {
  canGoBack: boolean;
  canGoForward: boolean;
  goBack: () => void;
  goForward: () => void;
  isPending: boolean;
  /** Which way the pending step goes, so only Undo or only Redo shows the wait. */
  pendingStep?: "back" | "forward" | null;
};

export const LearnDeckHistoryContext = createContext<LearnDeckHistory>({
  canGoBack: false,
  canGoForward: false,
  goBack: () => {},
  goForward: () => {},
  isPending: false,
  pendingStep: null,
});
